import React from "react";
import "./RemediesComingSoon.css";

function RemediesComingSoon() {
  return (
    <div className="remedies-soon-page">
      <div className="remedies-soon-card">
        <h1>Remedies</h1>
        <p>Under process. Soon will be updated.</p>
      </div>
    </div>
  );
}

export default RemediesComingSoon;
